import { useSnapshot } from 'valtio';

import { useTheme } from '@mui/material/styles';

import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';

import { BaseIndicator } from '@/components/common';

import {
  getBookingsExpandedQueryWhereClauseFromFilters,
  store,
} from '@/components/pages/EmissionsDashboard/store';

import { useGetBookingsExpandedCo2SumAggregateQuery } from '@/graphql/GetBookingsExpandedCO2SumAggregate.generated';

function TotalCo2eIndicator() {
  const theme = useTheme();
  const snap = useSnapshot(store);

  const where = getBookingsExpandedQueryWhereClauseFromFilters(
    snap as typeof store,
  );
  const [{ data, fetching, error: _error }, _reexecuteQuery] =
    useGetBookingsExpandedCo2SumAggregateQuery({
      variables: {
        where,
      },
    });

  const value =
    data?.container_insights_bookings_expanded_aggregate.aggregate?.sum
      ?.co2eq_kg || null;

  return (
    <BaseIndicator
      value={fetching ? null : value}
      sublabel="CO₂e kg"
      icon={<EnergySavingsLeafIcon color="secondary" />}
      color={theme.palette.secondary.main}
      loading={fetching}
    />
  );
}

export { TotalCo2eIndicator };
